export class DocumentVO{
 
public UploadedFile:String;
public DocumentLabel:String;
public UploadedFileName:String;
 
} 
